module.exports = __webpack_public_path__ + "img/grand-palm-hotel-2.6d26e5b4.jpg";